export const articles = {
  'goutou-luoli-funny-moments-2024': {
    id: 'fv-1',
    slug: 'goutou-luoli-funny-moments-2024',
    title: '狗头萝莉2024年度搞笑名场面合集',
    excerpt: '盘点2024年狗头萝莉直播中最搞笑的经典场面，每一个都让人笑到停不下来！',
    category: '搞笑片段',
    categorySlug: 'funny-clips',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20vibrant%20streaming%20studio%20scene%20with%20colorful%20RGB%20lighting%20and%20a%20gaming%20setup%20featuring%20a%20young%20female%20streamer%20laughing%20joyfully%20in%20front%20of%20a%20microphone%20and%20camera%20with%20chat%20messages%20on%20screen%20warm%20and%20energetic%20atmosphere&width=1200&height=675&seq=goutou-funny-detail-01&orientation=landscape',
    views: '128.5万',
    date: '2024-12-28',
    duration: '15:32',
    author: '狗头萝莉视频编辑部',
    content: `
      <p>2024年即将结束，这一年狗头萝莉带给我们太多欢乐。今天我们就来盘点一下年度最搞笑的直播名场面，每一个都值得反复回味！</p>

      <h2>第一名：意外翻车篇</h2>
      <p>在一次游戏直播中，狗头萝莉信誓旦旦地说自己已经熟练掌握了新英雄的操作技巧，结果开局不到三分钟就被对面单杀。她当时的表情从自信到震惊再到崩溃，堪称教科书级别的表情管理失败。弹幕瞬间被"哈哈哈"刷屏，热度直接飙升到平台第一。</p>
      <p>更搞笑的是，复活后她试图证明自己，结果又接连送了两个人头。最后她直接放弃治疗，开始自嘲式解说："我这不是在送人头，我是在给对面送温暖。"</p>

      <h2>第二名：神级接梗</h2>
      <p>在和粉丝连麦互动环节，有位粉丝突然唱起了跑调版的情歌，狗头萝莉不仅没有嫌弃，反而跟着一起合唱，并且即兴改编了歌词，把直播间的气氛推向高潮。这段视频被粉丝剪辑后在各大平台疯传。</p>

      <h2>第三名：厨房灾难</h2>
      <p>狗头萝莉首次尝试直播做饭，本想展示自己的厨艺，结果从切菜切到手，到把盐当成了糖，再到差点把锅烧穿，整个过程充满了意外和笑料。最后她端出来的那盘"黑暗料理"让人哭笑不得。</p>

      <h2>第四名：方言大挑战</h2>
      <p>粉丝要求狗头萝莉用各种方言读弹幕，从东北话到四川话，从粤语到闽南语，她的模仿能力惊人但发音却歪到天边。特别是她尝试说粤语时，连广东粉丝都表示"完全听不懂在说什么"。</p>

      <h2>第五名：深夜感性时刻</h2>
      <p>在一次深夜直播中，狗头萝莉突然感性起来，开始回忆自己刚开始直播时的艰辛时光。说到动情处眼眶泛红，但紧接着又因为一只飞进房间的虫子吓得尖叫，画风突变让粉丝们哭笑不得。</p>

      <p>以上就是2024年狗头萝莉最搞笑的五大名场面。这一年她带给我们无数欢乐，期待2025年她能带来更多精彩内容！</p>
    `,
    tags: ['搞笑', '名场面', '年度盘点', '直播', '狗头萝莉'],
    relatedSlugs: ['goutou-luoli-cooking-challenge', 'goutou-luoli-gaming-marathon', 'goutou-luoli-qa-session'],
  },
  'goutou-luoli-live-highlight-winter': {
    id: 'fv-2',
    slug: 'goutou-luoli-live-highlight-winter',
    title: '狗头萝莉冬季特别直播完整录屏',
    excerpt: '狗头萝莉冬季特别企划直播全程录制，包含粉丝问答、游戏挑战以及独家幕后花絮。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20winter%20themed%20streaming%20room%20with%20warm%20fairy%20lights%20and%20knitted%20decorations%20a%20streamer%20setup%20with%20dual%20monitors%20displaying%20gameplay%20and%20chat%20soft%20golden%20lighting%20creating%20a%20comfortable%20atmosphere&width=1200&height=675&seq=goutou-live-detail-02&orientation=landscape',
    views: '96.3万',
    date: '2024-12-15',
    duration: '2:18:45',
    author: '狗头萝莉视频编辑部',
    content: `
      <p>在这个寒冷的冬天，狗头萝莉为大家准备了一场温暖满满的特备直播。整场直播持续了两个多小时，内容丰富多彩，让我们一起回顾这场精彩的直播。</p>

      <h2>开场环节：冬日暖心问候</h2>
      <p>直播一开始，狗头萝莉就以一身可爱的冬季装扮亮相，背后是精心布置的冬日主题直播间，暖色调的灯光和毛绒装饰让整个画面充满温馨感。她向所有观众送上了冬日问候，并分享了最近的生活趣事。</p>

      <h2>互动环节一：粉丝问答</h2>
      <p>第一个环节是粉丝问答，狗头萝莉从弹幕中抽取了多个热门问题。从生活日常到未来计划，从兴趣爱好到个人感悟，她都非常真诚地回答了每一个问题。特别是当被问到"为什么要做直播"时，她分享了自己最初的心路历程，让很多粉丝感动不已。</p>

      <h2>互动环节二：游戏挑战</h2>
      <p>狗头萝莉挑选了三款冬季主题的小游戏进行挑战。虽然技术依旧"感人"，但她丰富的表情和搞笑的解说让整个环节充满了欢乐。最终她在粉丝的帮助下勉强通关，开心的样子像个孩子。</p>

      <h2>压轴环节：惊喜礼物</h2>
      <p>直播的最后，狗头萝莉抽取了多位幸运粉丝送出自己亲手准备的冬日礼物，包括手写明信片、定制周边等。她说："虽然礼物不贵重，但每一份都包含了我的心意。"</p>

      <p>整场直播在温暖的氛围中落下帷幕，不少粉丝表示这是今年看过最治愈的一场直播。</p>
    `,
    tags: ['冬季特辑', '直播录屏', '粉丝互动', '游戏挑战', '温暖'],
    relatedSlugs: ['goutou-new-year-special-2025', 'goutou-luoli-qa-session', 'goutou-luoli-daily-life-vlog'],
  },
  'goutou-luoli-fan-meeting-2024': {
    id: 'fv-3',
    slug: 'goutou-luoli-fan-meeting-2024',
    title: '狗头萝莉2024粉丝见面会全程记录',
    excerpt: '记录狗头萝莉首次线下粉丝见面会的珍贵时刻，包含互动游戏、粉丝表白、签名合影等感动瞬间。',
    category: '粉丝互动',
    categorySlug: 'fan-interactions',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fan%20meeting%20event%20scene%20with%20a%20popular%20streamer%20on%20stage%20interacting%20with%20enthusiastic%20audience%20members%20colorful%20stage%20lighting%20and%20decorations%20warm%20and%20exciting%20atmosphere&width=1200&height=675&seq=goutou-fan-detail-03&orientation=landscape',
    views: '156.8万',
    date: '2024-11-20',
    duration: '45:18',
    author: '狗头萝莉视频编辑部',
    content: `
      <p>2024年11月20日，狗头萝莉举办了她的首次线下粉丝见面会。数百名粉丝从全国各地赶来，只为亲眼见到他们喜爱的主播。让我们一起回顾这场难忘的活动。</p>

      <h2>开场：粉丝的热情</h2>
      <p>活动还没开始，场馆外就已经排起了长队。粉丝们举着应援牌、穿着定制T恤，脸上洋溢着期待的笑容。当狗头萝莉出现在舞台上时，全场爆发出震耳欲聋的欢呼声。</p>

      <h2>环节一：近距离互动</h2>
      <p>狗头萝莉邀请多位粉丝上台参与互动游戏，从你画我猜到知识问答，现场笑声不断。她还为每位上台的粉丝准备了签名礼物，并亲切地与他们合影留念。</p>

      <h2>环节二：粉丝表白时刻</h2>
      <p>最感人的环节莫过于粉丝表白。多位粉丝上台分享了自己与狗头萝莉的故事。有人说是她的直播陪伴自己度过了低谷期，有人说因为她的正能量改变了生活态度。现场一度气氛感人，狗头萝莉也忍不住红了眼眶。</p>

      <h2>环节三：惊喜表演</h2>
      <p>狗头萝莉为粉丝们准备了一段精心排练的舞蹈表演，虽然自称"舞痴"，但认真的态度和可爱的表现赢得了全场掌声。</p>

      <h2>尾声：约定未来</h2>
      <p>活动最后，狗头萝莉向所有到场的粉丝表达了感谢，并承诺未来会带来更多优质内容。她说："没有你们的支持，就没有今天的我。我会继续努力，不辜负大家的期待。"</p>

      <p>这场见面会不仅拉近了狗头萝莉与粉丝之间的距离，也成为2024年最温暖的回忆之一。</p>
    `,
    tags: ['粉丝见面会', '线下活动', '粉丝互动', '感动', '首秀'],
    relatedSlugs: ['goutou-luoli-qa-session', 'goutou-luoli-live-highlight-winter', 'goutou-luoli-funny-moments-2024'],
  },
  'goutou-new-year-special-2025': {
    id: 'lv-1',
    slug: 'goutou-new-year-special-2025',
    title: '狗头萝莉2025新年特别直播：跨年倒计时',
    excerpt: '和狗头萝莉一起迎接2025年！跨年夜特别直播，包含年度回顾、新年愿望、粉丝连麦等精彩环节。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20festive%20new%20year%20celebration%20streaming%20scene%20with%20golden%20and%20silver%20decorations%20confetti%20and%20sparkling%20lights%20a%20streaming%20setup%20with%20countdown%20timer%20on%20screen%20joyful%20atmosphere&width=1200&height=675&seq=goutou-newyear-detail-01&orientation=landscape',
    views: '89.2万',
    date: '2025-01-01',
    duration: '3:42:15',
    author: '狗头萝莉视频编辑部',
    content: `
      <p>跨年夜，狗头萝莉开启了一场长达近4小时的特别直播，与数十万粉丝一起迎接2025年的到来。</p>
      <h2>年度回顾</h2>
      <p>狗头萝莉精心制作了一段年度回顾视频，记录了2024年的重要时刻。从粉丝突破百万到首次线下见面会，每一个里程碑都让粉丝们感慨万千。</p>
      <h2>新年愿望</h2>
      <p>在倒计时环节，狗头萝莉和粉丝一起许下新年愿望。她说最大的愿望是能继续做自己喜欢的事情，陪伴大家度过更多美好时光。</p>
      <h2>连麦互动</h2>
      <p>随机邀请了多位粉丝连麦，大家一起倒数迎接新年。零点钟声敲响时，直播间被祝福和礼物刷屏，气氛达到最高潮。</p>
    `,
    tags: ['新年', '跨年', '特别直播', '2025', '年终回顾'],
    relatedSlugs: ['goutou-luoli-live-highlight-winter', 'goutou-luoli-funny-moments-2024', 'goutou-luoli-daily-life-vlog'],
  },
  'goutou-luoli-cooking-challenge': {
    id: 'lv-2',
    slug: 'goutou-luoli-cooking-challenge',
    title: '狗头萝莉厨房挑战：黑暗料理大赏',
    excerpt: '狗头萝莉首次尝试做饭，结果翻车不断！从切菜到调味全程笑料百出。',
    category: '搞笑片段',
    categorySlug: 'funny-clips',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20messy%20kitchen%20scene%20with%20a%20young%20female%20content%20creator%20attempting%20to%20cook%20with%20flour%20spilled%20everywhere%20and%20funny%20facial%20expression%20warm%20kitchen%20lighting&width=1200&height=675&seq=goutou-cook-detail-02&orientation=landscape',
    views: '112.6万',
    date: '2024-12-25',
    duration: '22:15',
    author: '狗头萝莉视频编辑部',
    content: '<p>圣诞节当天，狗头萝莉决定挑战自己的厨艺极限...</p><h2>备菜阶段</h2><p>光是切洋葱就让她泪流满面...</p><h2>烹饪阶段</h2><p>调味环节更是灾难，把酱油当成了老抽...</p><h2>成品展示</h2><p>最终的成品只能说"创意十足"...</p>',
    tags: ['厨房挑战', '搞笑', '翻车', '圣诞特辑', '黑暗料理'],
    relatedSlugs: ['goutou-luoli-funny-moments-2024', 'goutou-luoli-daily-life-vlog', 'goutou-luoli-gaming-marathon'],
  },
  'goutou-luoli-gaming-marathon': {
    id: 'lv-3',
    slug: 'goutou-luoli-gaming-marathon',
    title: '狗头萝莉通宵游戏马拉松：恐怖游戏特辑',
    excerpt: '狗头萝莉挑战连续玩10款恐怖游戏！全程尖叫不断。',
    category: '精彩集锦',
    categorySlug: 'highlights',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20gaming%20room%20at%20night%20with%20a%20streamer%20reacting%20to%20a%20horror%20game%20on%20a%20large%20monitor%20purple%20and%20red%20ambient%20lighting%20dramatic%20mood&width=1200&height=675&seq=goutou-horror-detail-03&orientation=landscape',
    views: '143.7万',
    date: '2024-12-20',
    duration: '18:42',
    author: '狗头萝莉视频编辑部',
    content: '<p>狗头萝莉挑战通宵玩恐怖游戏...</p><h2>游戏一</h2><p>开局就被吓到尖叫...</p><h2>中途崩溃</h2><p>玩到一半直接躲到桌子底下...</p><h2>坚持到底</h2><p>虽然害怕但还是坚持完成了挑战...</p>',
    tags: ['恐怖游戏', '游戏马拉松', '尖叫', '精彩集锦', '通宵'],
    relatedSlugs: ['goutou-luoli-funny-moments-2024', 'goutou-luoli-collab-stream', 'goutou-luoli-cooking-challenge'],
  },
  'goutou-luoli-daily-life-vlog': {
    id: 'lv-4',
    slug: 'goutou-luoli-daily-life-vlog',
    title: '狗头萝莉的一天：从起床到直播的日常Vlog',
    excerpt: '带你走进狗头萝莉的日常生活！展现最真实的狗头萝莉。',
    category: '日常Vlog',
    categorySlug: 'daily-vlogs',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20lifestyle%20vlog%20aesthetic%20scene%20with%20a%20young%20female%20influencer%20in%20a%20modern%20apartment%20doing%20morning%20routine%20natural%20sunlight%20through%20large%20windows%20minimalist%20interior&width=1200&height=675&seq=goutou-vlog-detail-04&orientation=landscape',
    views: '76.4万',
    date: '2024-12-18',
    duration: '28:10',
    author: '狗头萝莉视频编辑部',
    content: '<p>想知道狗头萝莉的一天是怎么度过的吗？</p><h2>早晨7:00</h2><p>闹钟响起，狗头萝莉开始新的一天...</p><h2>上午10:00</h2><p>健身时间...</p><h2>下午准备</h2><p>为晚上的直播做准备...</p>',
    tags: ['日常Vlog', '生活记录', '真实', '直播幕后', '一天'],
    relatedSlugs: ['goutou-luoli-behind-the-scenes', 'goutou-luoli-live-highlight-winter', 'goutou-luoli-style-evolution'],
  },
  'goutou-luoli-qa-session': {
    id: 'lv-5',
    slug: 'goutou-luoli-qa-session',
    title: '狗头萝莉粉丝问答：你们最想知道的事',
    excerpt: '狗头萝莉首次开启真心话模式！回答粉丝最关心的50个问题。',
    category: '粉丝互动',
    categorySlug: 'fan-interactions',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20QandA%20session%20streaming%20scene%20with%20a%20female%20streamer%20reading%20fan%20questions%20from%20a%20large%20screen%20with%20chat%20messages%20colorful%20studio%20lighting%20intimate%20atmosphere&width=1200&height=675&seq=goutou-qa-detail-05&orientation=landscape',
    views: '201.3万',
    date: '2024-12-10',
    duration: '1:05:30',
    author: '狗头萝莉视频编辑部',
    content: '<p>狗头萝莉终于开启了真心话问答环节...</p><h2>关于直播</h2><p>被问到为什么要做直播...</p><h2>关于生活</h2><p>分享了日常生活中的小习惯...</p><h2>关于未来</h2><p>透露了明年的计划和目标...</p>',
    tags: ['粉丝问答', '真心话', '互动', 'Q&A', '直播'],
    relatedSlugs: ['goutou-luoli-fan-meeting-2024', 'goutou-luoli-behind-the-scenes', 'goutou-new-year-special-2025'],
  },
  'goutou-luoli-collab-stream': {
    id: 'lv-6',
    slug: 'goutou-luoli-collab-stream',
    title: '狗头萝莉联动特别篇：与好友的欢乐双排',
    excerpt: '狗头萝莉邀请神秘嘉宾一起直播！欢乐双排变成互坑现场。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20collaborative%20streaming%20scene%20with%20two%20streamers%20side%20by%20side%20laughing%20and%20playing%20games%20together%20split%20screen%20monitors%20dynamic%20and%20fun%20atmosphere&width=1200&height=675&seq=goutou-collab-detail-06&orientation=landscape',
    views: '167.9万',
    date: '2024-12-05',
    duration: '1:52:38',
    author: '狗头萝莉视频编辑部',
    content: '<p>狗头萝莉邀请了好友一起直播双排...</p><h2>默契开局</h2><p>两人自信满满进入游戏...</p><h2>翻车现场</h2><p>配合失误频频，弹幕笑疯...</p><h2>欢乐收尾</h2><p>虽然输了游戏但赢了快乐...</p>',
    tags: ['联动', '双排', '游戏', '合作', '搞笑'],
    relatedSlugs: ['goutou-luoli-gaming-marathon', 'goutou-luoli-funny-moments-2024', 'goutou-luoli-live-highlight-winter'],
  },
  'goutou-luoli-most-memorable-moments': {
    id: 'ht-1',
    slug: 'goutou-luoli-most-memorable-moments',
    title: '盘点狗头萝莉十大最难忘直播瞬间',
    excerpt: '从出道至今，狗头萝莉创造了许多令人难忘的直播瞬间。让我们一起回顾这些经典时刻。',
    category: '精彩集锦',
    categorySlug: 'highlights',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20montage%20style%20collage%20of%20memorable%20streaming%20moments%20featuring%20a%20female%20streamer%20in%20various%20emotional%20states%20cinematic%20lighting%20nostalgic%20atmosphere&width=1200&height=675&seq=goutou-moments-detail-01&orientation=landscape',
    views: '98.6万',
    date: '2024-12-22',
    duration: '20:15',
    author: '狗头萝莉视频编辑部',
    content: '<p>从默默无闻到拥有百万粉丝，狗头萝莉的直播之路充满了难忘的瞬间...</p>',
    tags: ['盘点', '经典瞬间', '回顾', '成长', '直播史'],
    relatedSlugs: ['goutou-luoli-funny-moments-2024', 'goutou-luoli-fan-meeting-2024', 'goutou-luoli-style-evolution'],
  },
  'goutou-luoli-style-evolution': {
    id: 'ht-2',
    slug: 'goutou-luoli-style-evolution',
    title: '狗头萝莉造型进化史：从青涩到惊艳',
    excerpt: '回顾狗头萝莉从早期直播到现在的造型变化，每一个阶段都见证了她的成长。',
    category: '最新动态',
    categorySlug: 'latest-news',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fashion%20evolution%20timeline%20concept%20with%20a%20young%20female%20influencer%20in%20different%20stylish%20outfits%20soft%20studio%20lighting%20fashion%20editorial%20style&width=1200&height=675&seq=goutou-style-detail-02&orientation=landscape',
    views: '85.3万',
    date: '2024-12-16',
    duration: '12:45',
    author: '狗头萝莉视频编辑部',
    content: '<p>从最初素颜出镜的青涩女孩，到如今精致时尚的当红主播...</p>',
    tags: ['造型', '时尚', '进化', '变迁', '风格'],
    relatedSlugs: ['goutou-luoli-daily-life-vlog', 'goutou-luoli-most-memorable-moments', 'goutou-luoli-behind-the-scenes'],
  },
  'goutou-luoli-behind-the-scenes': {
    id: 'ht-3',
    slug: 'goutou-luoli-behind-the-scenes',
    title: '狗头萝莉幕后故事：你不知道的直播背后',
    excerpt: '镜头之外的狗头萝莉是什么样的？揭秘直播间的准备工作、团队的日常运作。',
    category: '最新动态',
    categorySlug: 'latest-news',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20view%20of%20a%20streaming%20studio%20with%20equipment%20setup%20cameras%20lights%20and%20a%20team%20preparing%20for%20a%20live%20broadcast%20documentary%20style&width=1200&height=675&seq=goutou-bts-detail-03&orientation=landscape',
    views: '72.1万',
    date: '2024-12-08',
    duration: '16:30',
    author: '狗头萝莉视频编辑部',
    content: '<p>很多人只看到狗头萝莉在镜头前的光鲜，却不知道背后付出的努力...</p>',
    tags: ['幕后', '揭秘', '直播背后', '团队', '努力'],
    relatedSlugs: ['goutou-luoli-daily-life-vlog', 'goutou-luoli-qa-session', 'goutou-luoli-style-evolution'],
  },
};

export const siteInfo = {
  name: '狗头萝莉视频',
  description: '狗头萝莉视频网站，提供最新最全的狗头萝莉精彩视频内容合集，包含直播录屏、搞笑片段、日常Vlog等精选视频资源，是狗头萝莉粉丝的最佳聚集地。',
  keywords: '狗头萝莉, 狗头萝莉视频, 直播录屏, 搞笑视频, 粉丝互动',
  url: 'https://goutouluoli.com',
  foundingYear: '2023',
  email: 'contact@goutouluoli.com',
  address: '中国上海市浦东新区张江高科技园区',
  socialLinks: {
    bilibili: 'https://space.bilibili.com/',
    weibo: 'https://weibo.com/',
    douyin: 'https://www.douyin.com/',
  },
};